var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-aside_total"},[_c('div',{staticClass:"bank-aside_total__text fz14"},[_vm._v("Total of assets "),_c('br'),_vm._v(" as of "+_vm._s(_vm.getToday))]),_c('div',{staticClass:"bank-aside_total__numb fz14 fw500"},[_vm._v(_vm._s(_vm._f("formatNumberTwo")(_vm.totalSumm))+" USD")])])
}
var staticRenderFns = []

export { render, staticRenderFns }